'use client';

import '@ui5/webcomponents/dist/Breadcrumbs.js';
import { BreadcrumbsDesign, BreadcrumbsSeparatorStyle } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * Enables users to navigate between items by providing a list of links to previous steps in the user's navigation path. It helps the user to be aware of their location within the application and allows faster navigation.
 *
 * The last three steps can be accessed as links directly, while the remaining links prior to them are available in a drop-down menu.
 *
 * You can choose the type of separator to be used from a number of predefined options.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Breadcrumbs)
 */
const Breadcrumbs = withWebComponent('ui5-breadcrumbs', ['design', 'separatorStyle'], [], [], ['item-click']);
Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.defaultProps = {
  design: BreadcrumbsDesign.Standard,
  separatorStyle: BreadcrumbsSeparatorStyle.Slash
};
export { Breadcrumbs };